




////////////////////////////////////////////////////////////////////////////////
//                                                                            //
// BEFORE DEVELOPING FURTHER, MERGE THIS ONE AS A HIGHER ORDER COMPONENT WITH //
//                                                                            //
//                           USER ENVELOPES                                   //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////



































import React, { Component } from 'react';
// import * as firebase from 'firebase';
import DisplayFrame from './DisplayFrame';
import { select } from './helpers/fuseHelper.js';

import { sendToPostOffice, publicMail, snapToArrayWithKeys } from './helpers/fireHelper';

class Envelopes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      metaEnvelopes: [],
      envelopes: [],
      selectedKey: false,
      searchString: ''
    }
    this.handleEnvelopeDelete = this.handleEnvelopeDelete.bind(this)
  }
  componentDidMount() {
    this.mailBox = publicMail;
    this.mailBox.on('value', function(snap) {
      this.setState({ metaEnvelopes: snapToArrayWithKeys(snap) })
    }.bind(this))
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.searchString !== this.state.searchString) {
      this.setState({ searchString: nextProps.searchString })
    }
  }

  componentWillUnmount() {
    this.mailBox.off();
  }

  handleEnvelopeDelete(k) {
    sendToPostOffice("delete", k);
  }

  render() {

    const sorted = this.state.searchString.length < 2 ?
      this.state.metaEnvelopes.sort(function(a, b) {
        if(a.name < b.name) return -1;
        if(a.name > b.name) return 1;
        return 0;
      })
      :
      select(this.state.metaEnvelopes, this.state.searchString)

    const NewFrames = sorted.map(function(envelope, i) {
      return (
        <DisplayFrame onEnvelopeDelete={this.handleEnvelopeDelete}
         envelope={envelope} envelopeKey={envelope.key} key={envelope.key}/>
      )
    }.bind(this))

    return (
      // <div style={{backgroundColor: '#eee', }}>
      <div style={{backgroundColor: '#424242', }}>
        <div className="galleryContainer" style={{paddingTop: '95px'}}>
          {NewFrames}
        </div>
      </div>
    )
  }
}

export default Envelopes



// WEBPACK FOOTER //
// ./src/PublicEnvelopes.js